import React, { useEffect, useMemo, useState } from "react";
import {
  formatDataNatcomAirtimCompate,
  getDateChangeTime,
} from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTime from "../../../components/FilterTime";
import { useSelector } from "react-redux";
import DashboardCompare from "../../components/DashboardCompare";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";

export default function Compare({ tabActive, handleGetData, isMissCall = false }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerNatcom?.data) || {};
  const { vm_digicel = [], vm_natcom = [] } = result;

  useEffect(() => {
    if (tabActive !== "3") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataChart = useMemo(() => {
    const convertData = formatDataNatcomAirtimCompate(vm_natcom,startDate,endDate);
    return convertData || [];
  }, [vm_natcom, startDate, endDate]);

  const dataChartDigicel = useMemo(() => {
    const convertData = formatDataNatcomAirtimCompate(vm_digicel,startDate,endDate, true);
    return convertData || [];
  }, [vm_digicel, startDate, endDate]);

  const dataChartQtyNatcom = useMemo(() => {
    const convertData = formatDataNatcomAirtimCompate(vm_natcom,startDate,endDate, false, true);
    return convertData || [];
  }, [vm_digicel, startDate, endDate]);

  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>

      <Tabs defaultActiveKey="1">
        <TabPane tab="NATCOM" key="1">
          <div>
            <DashboardCompare
              dataChart={dataChart}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="DIGICEL" key="2">
          <div>
            <DashboardCompare
              dataChart={dataChartDigicel}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="QUANTITY NATCOM" key="3">
          <div>
            <DashboardCompare
              dataChart={dataChartQtyNatcom}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
}
